import { Form } from "@redriver/cinnamon-mui";
import { shortlistedResourceAvailabilityLookup } from "modules/lookups";

const ResourceAvailabilityDropdown = (props) => (
  <Form.Dropdown lookup={shortlistedResourceAvailabilityLookup} {...props} />
);

export default ResourceAvailabilityDropdown;
